import { render, staticRenderFns } from "./ServiceInquiryCreate.vue?vue&type=template&id=ee2a1340&scoped=true"
import script from "./ServiceInquiryCreate.vue?vue&type=script&lang=js"
export * from "./ServiceInquiryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2a1340",
  null
  
)

export default component.exports